import { Api } from '@/interface/api';

/**
 * 获取赛事直播列表
 * @param accountId
 */
const getRaceVideoList: Api = {
    url: '/api/project/proxy/api/race-video',
    method: 'get',
};

export { getRaceVideoList };
